import { provideHttpClient, withInterceptors } from '@angular/common/http';
import {
  ApplicationConfig,
  inject,
  isDevMode,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
} from '@angular/core';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { provideServiceWorker } from '@angular/service-worker';

import { provideApollo } from './core/api/apollo.providers';
import { authInterceptor } from './core/auth/auth.interceptor';
import { AuthService } from './core/auth/auth.service';
import { provideSentry } from './core/observability/sentry.providers';
import { InstallPromptService } from './core/pwa/install-prompt.service';
import { routes } from './app.routes';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes, withComponentInputBinding()),
    provideHttpClient(withInterceptors([authInterceptor])),
    provideApollo(),
    provideSentry(),
    provideServiceWorker('ngsw-worker.js', {
      enabled: !isDevMode(),
      registrationStrategy: 'registerWhenStable:30000',
    }),
    // Hidratação silenciosa do cookie HttpOnly no boot — se o usuário
    // tem refreshToken válido, a sessão é restaurada antes do primeiro
    // render. Em qualquer falha, fica deslogado (rotas protegidas
    // redirecionam pra /auth/login).
    provideAppInitializer(() => inject(AuthService).hidratarDoCookie()),
    // Força instanciação eager do InstallPromptService — o listener de
    // `beforeinstallprompt` precisa estar registrado antes do browser
    // disparar o evento (que pode acontecer já no primeiro paint).
    provideAppInitializer(() => {
      inject(InstallPromptService);
    }),
  ],
};
